document.addEventListener('DOMContentLoaded', function() {
  const sectionbutton = document.querySelectorAll('.faq-section-btn');
  const questionLists = document.querySelectorAll('.faq-question-list');
  const questionbutton = document.querySelectorAll('.faq-question-btn');
  const answerPanels = document.querySelectorAll('.faq-answer-detail');
  const backbutton = document.querySelectorAll('.back-to-questions');
  const searchInput = document.getElementById('faq-search');
  const container = document.querySelector('.faq-container');

  if (!container) return;

  let historyStack = [];
  let fullPageResultsRef = null;
  let lastFullQuery = '';

  const backLabels = document.querySelectorAll('.back-to-questions span');

  /* ---------- helpers ---------- */
  function resetSections() {
    const faqSectionsEl = document.querySelector('.faq-sections');
    if (faqSectionsEl) faqSectionsEl.style.display = '';

    if (container) {
      container.classList.remove('question-open');
      container.setAttribute("data-section","");
    }

    questionLists.forEach(list => {
      list.classList.remove('active-question-list','question-open');
      list.style.display = ''; 
    });

    answerPanels.forEach(panel => {
      panel.classList.remove('active-answer-panel','question-open');
      panel.style.display = 'none'; 
    });
  }

  function activateSection(section) {
    const faqSectionsEl = document.querySelector('.faq-sections');
    if (faqSectionsEl) faqSectionsEl.style.display = '';
    container.setAttribute("data-section", section);

    questionLists.forEach(list => {
      const isActive = list.dataset.section === section;
      list.classList.toggle('active-question-list', isActive);
      list.classList.remove('question-open');
      list.style.display = '';
    });

    answerPanels.forEach(panel => {
      panel.classList.remove('active-answer-panel','question-open');
    });

    if (window.innerWidth <= 768) {
      const mobileOpen = document.querySelector(".active-question-list");
      if (mobileOpen) mobileOpen.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }

  function setBackLabelForPanel(panel, type, data = {}) {
    if (!panel) return;
    const span = panel.querySelector('.back-to-questions span');
    if (type === 'search-full') {
      span.innerHTML = '<span class="langEN">Search Results</span><span class="langFR">Résultats de la recherche</span>';
      span.dataset.section = 'search';
    } else if (type === 'question') {
      span.innerHTML = '<span class="langEN">Previous Question</span><span class="langFR">Question précédente</span>';
      span.dataset.section = '';
    } else if (type === 'section') {
      const key = data.section || 'most_frequent_questions';
      const btn = document.querySelector(`.faq-section-btn[data-section="${key}"]`);
      const title = btn?.textContent?.trim() || key;
      span.textContent = title;
      span.dataset.section = key;
    } else {
      span.innerHTML = '<span class="langEN">Most Frequent Questions</span><span class="langFR">Questions les plus fréquentes</span>';
      span.dataset.section = 'most_frequent_questions';
    }
  }

  function setupSectionButtons() {
    sectionbutton.forEach(btn => {
      btn.addEventListener('click', function() {
        const section = this.dataset.section;

        if (window.innerWidth <= 768) {
          const list = document.querySelector(`.faq-question-list[data-section="${section}"]`);
          if (!list) return;

          const isOpen = list.classList.contains('active-question-list');
          if (isOpen) {
            list.classList.remove('active-question-list');
          } else {
            resetSections();
            activateSection(section);
            list.scrollIntoView({ behavior: 'auto', block: 'start' });
          }

        } else {
          resetSections();
          activateSection(section);
          historyStack = [];
        }
        if (fullPageResultsRef) {
          fullPageResultsRef.style.display = 'none';
          fullPageResultsRef = null;
          lastFullQuery = '';
        } else {
          const fullPage = document.querySelector('.faq-search-results-fullpage');
          if (fullPage) fullPage.style.display = 'none';
        }
      });
    });
  }

  function openQuestion(qid, origin = null, setPrev = true) {
    const sectionOfQ = (qid || '').split('-')[0] || null;
    const target = document.getElementById('panel-' + qid);
    if (!target) return;

    if (setPrev) {
      if (origin) historyStack.push(origin);
      else {
        const activeAnswer = document.querySelector('.faq-answer-detail.active-answer-panel');
        if (activeAnswer) {
          historyStack.push({ type: 'question', question: activeAnswer.id.replace('panel-','') });
        } else {
          const activeListSection = document.querySelector('.faq-question-list.active-question-list')?.dataset.section;
          historyStack.push({ type: 'section', section: activeListSection || sectionOfQ || 'most_frequent_questions' });
        }
      }
    }

    document.querySelectorAll('.faq-sections, .faq-question-list, .faq-answer-detail').forEach(el => {
      el.classList.remove('active-question-list','active-answer-panel','question-open');
    });

    target.style.display = '';
    target.classList.add('active-answer-panel');
    container.classList.add('question-open');

    if (window.innerWidth <= 768) {
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
    }

    setBackLabelForPanel(target, origin?.type || 'section', origin || { section: sectionOfQ });
  }

  setupSectionButtons();

  questionbutton.forEach(btn => {
    btn.addEventListener('click', function() {
      const qid = this.dataset.question;
      const isRelated = this.closest('.faq-related-questions');
      const parentList = this.closest('.faq-question-list');
      const fromSection = parentList ? parentList.dataset.section : null;
      if (isRelated) {
        const currentQ = document.querySelector('.faq-answer-detail.active-answer-panel')?.id.replace('panel-','') || null;
        openQuestion(qid, currentQ ? { type: 'question', question: currentQ } : null);
      } else if (fromSection === 'most_frequent_questions') {
        openQuestion(qid, { type: 'section', section: 'most_frequent_questions' });
      } else {
        const section = qid.split('-')[0];
        openQuestion(qid, { type: 'section', section });
      }
    });
  });

backbutton.forEach(btn => {
  btn.addEventListener('click', function() {
    const parent = this.closest('.faq-answer-detail');
    if (parent) parent.classList.remove('active-answer-panel');

    container.classList.remove('question-open');

    // Hide full-page search results if present
    if (fullPageResultsRef) {
      fullPageResultsRef.style.display = 'none';
      fullPageResultsRef = null;
      lastFullQuery = '';
    } else {
      const fullPage = document.querySelector('.faq-search-results-fullpage');
      if (fullPage) fullPage.style.display = 'none';
    }

    const last = historyStack.length ? historyStack.pop() : null;

    if (!last) {
      resetSections();
      activateSection('most_frequent_questions');
      return;
    }

    if (last.type === 'section') {
      resetSections();
      activateSection(last.section);
      answerPanels.forEach(p => setBackLabelForPanel(p, 'section', { section: last.section }));
    } else if (last.type === 'question') {
      openQuestion(last.question, null, false);
      const nextPeek = historyStack.length ? historyStack[historyStack.length - 1] : null;
      const restoredPanel = document.getElementById('panel-' + last.question);
      if (nextPeek && restoredPanel) setBackLabelForPanel(restoredPanel, nextPeek.type, nextPeek);
      else if (restoredPanel) setBackLabelForPanel(restoredPanel, 'section', { section: 'most_frequent_questions' });
    } else if (last.type === 'search-full') {
      searchInput.value = last.query;
      performFaqSearch(last.query);
    } else {
      resetSections();
      activateSection('most_frequent_questions');
    }

    // MOBILE: ensure question lists are visible and panels are in original place
    if (window.innerWidth <= 768) {
      questionLists.forEach(list => list.style.display = '');
      answerPanels.forEach(p => {
        if (!container.contains(p)) container.appendChild(p); // restore to container just in case
        p.style.display = p.classList.contains('active-answer-panel') ? '' : 'none';
      });
    }
  });
});
// ----- Floating + full-page search -----
if (searchInput) {
  // ensure floatingResults exists first
  let floatingResults = document.querySelector('.faq-search-results-floating');
  if (!floatingResults) {
    floatingResults = document.createElement('div');
    floatingResults.classList.add('faq-search-results-floating');
    floatingResults.style.display = 'none';
    if (container) container.appendChild(floatingResults);
  }

  // single close button
  let closeBtn = floatingResults.querySelector('.faq-search-close');
  if (!closeBtn) {
    closeBtn = document.createElement('i');
    closeBtn.classList.add('fas','fa-times','faq-search-close');
    closeBtn.setAttribute('aria-label','Close search results');
    closeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      floatingResults.style.display = 'none';
      searchInput.value = '';
    });
    floatingResults.appendChild(closeBtn);
  }

  // utility: normalize text (lowercase, remove punctuation, split words)
  function normalizeText(str) {
    return str.toLowerCase().replace(/[^\w\s]/g,'').split(/\s+/).filter(Boolean);
  }

    const STOP_WORDS = [
    // English
    'the','and','or','to','of','a','for','in','on','is','at','by','with','an','be','as','it','that','this','from','are','was','were','but','if','not',
    // French
    'le','la','les','de','des','du','et','ou','un','une','pour','dans','sur','est','à','au','aux','par','avec','en','ce','cet','cette','ces','ça','ils','elle','elles','il'
    ];

    function searchMatch(queryWords, textWords) {
    // Remove noise words
    const filtered = queryWords.filter(qw => !STOP_WORDS.includes(qw));

    // If everything was filtered out, don’t match anything
    if (!filtered.length) return false;

    // Partial match: any query word matches the start of any text word
    return filtered.some(qw => textWords.some(tw => tw.startsWith(qw)));
    }

  function getPriorityScore(qWords, panel, qButton) {
    const questionText = normalizeText(qButton?.textContent || '');
    const answerText = normalizeText(panel.querySelector('.faq-answer-body')?.textContent || '');
    const keywordText = normalizeText(panel.dataset.keywords || '');
    const translatedText = normalizeText(panel.dataset.translated || '');
    
    let score = 0;
    if (searchMatch(qWords, questionText)) score += 100;
    if (searchMatch(qWords, answerText)) score += 50;
    if (searchMatch(qWords, keywordText)) score += 25;
    if (searchMatch(qWords, translatedText)) score += 10;
    return score;
    }

  // Floating results (live search)
  searchInput.addEventListener('input', function() {
    const query = this.value.trim().toLowerCase();
    if (!query) {
      floatingResults.style.display = 'none';
      return;
    }
    const qWords = normalizeText(query);
    const resultsList = floatingResults.querySelector('.faq-search-results-list') || document.createElement('div');
    resultsList.classList.add('faq-search-results-list');
    resultsList.innerHTML = '';
    floatingResults.appendChild(resultsList);

    let results = [];
    questionLists.forEach(list => {
      list.querySelectorAll('.faq-question-btn').forEach(q => {
        if (q.closest('.faq-related-questions')) return;
         const text = q.textContent.trim();
        if (!text) return; // skip empty buttons
        const panel = document.getElementById('panel-' + q.dataset.question);
        if (!panel) return;
        const score = getPriorityScore(qWords, panel, q);
        if (score > 0) results.push({ panel, q, score, section: list.dataset.section });
      });
    });

    // sort descending by score
    results.sort((a,b) => b.score - a.score);

    const seen = new Set();
    results.forEach(r => {
      const text = r.q.textContent.trim();
      if (!seen.has(text)) {
        seen.add(text);
        const answerText = r.panel.querySelector('.faq-answer-body')?.textContent.trim() || '';
        const item = document.createElement('div');
        item.classList.add('faq-search-results-item');
        item.innerHTML = `<p class="search-q">${text}</p><p class="search-a">${answerText.substring(0,100)}...</p>`;
        item.addEventListener('click', function() {
          floatingResults.style.display = 'none';
          openQuestion(r.q.dataset.question, { type: 'section', section: r.section });
        });
        resultsList.appendChild(item);
      }
    });

    floatingResults.style.display = seen.size ? 'block' : 'none';
  });

  function performFaqSearch(query) {
    query = query.trim().toLowerCase();
    if (!query) return;

    floatingResults.style.display = 'none';
    fullPageResultsRef = document.querySelector('.faq-search-results-fullpage');
    if (!fullPageResultsRef) return;

    const querySpan = fullPageResultsRef.querySelector('.search-query');
    if (querySpan) querySpan.textContent = query;

    let resultsContainer = fullPageResultsRef.querySelector('.faq-search-results-list');
    if (!resultsContainer) {
      resultsContainer = document.createElement('div');
      resultsContainer.classList.add('faq-search-results-list');
      fullPageResultsRef.appendChild(resultsContainer);
    }
    resultsContainer.innerHTML = '';
    fullPageResultsRef.style.display = 'block';
    resetSections();
    container.setAttribute("data-section", "search");

    const qWords = normalizeText(query);
    let results = [];

    questionLists.forEach(list => {
      list.querySelectorAll('.faq-question-btn').forEach(q => {
        if (q.closest('.faq-related-questions')) return;
        const text = q.textContent.trim();
        if (!text) return;

        const panel = document.getElementById('panel-' + q.dataset.question);
        if (!panel) return;

        const score = getPriorityScore(qWords, panel, q);
        if (score > 0) results.push({ panel, q, score, section: list.dataset.section });
      });
    });

    results.sort((a, b) => b.score - a.score);

    const seen = new Set();
    results.forEach(r => {
      const text = r.q.textContent.trim();
      if (!seen.has(text)) {
        seen.add(text);
        const answerText = r.panel.querySelector('.faq-answer-body')?.textContent.trim() || '';
        const item = document.createElement('div');
        item.classList.add('faq-search-results-item');
        item.innerHTML = `<p class="search-q">${text}</p><p class="search-a">${answerText.substring(0,150)}...</p>`;
        item.addEventListener('click', function() {
          fullPageResultsRef.style.display = 'none';
          openQuestion(r.q.dataset.question, { type: 'search-full', query });
        });
        resultsContainer.appendChild(item);
      }
    });

    if (!seen.size) resultsContainer.innerHTML = '<p><span class="langFR">Aucun résultat trouvé.</span><span class="langEN">No results found.</span></p>';
  }
  // --- Bind to Enter key ---
  searchInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      performFaqSearch(this.value);
    }
  });
  // close floating if clicking outside
  document.getElementById("faq-search-submit").addEventListener('click', function(e) {
    if (floatingResults && !floatingResults.contains(e.target) && e.target !== searchInput) {
      floatingResults.style.display = 'none';
    }
  });
}

// Make all FAQ buttons and section headers keyboard accessible
function setupKeyboardAccessibility() {
  document.querySelectorAll('.faq-question-btn, .faq-section-btn, .faq-search-results-item, .faq-search-close').forEach(el => {
    el.setAttribute('tabindex', '0');

    el.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        el.click(); // triggers existing click handlers
      }
    });
  });
}

// Call this after generating all FAQ elements
setupKeyboardAccessibility();
  // Grab the phone number from the <a> inside .phone-number
  const preRelObserver = new MutationObserver(() => {
    const preRelPhone = document.querySelector(".phone-number a[data-store-phone]");
    const preRelHelp = document.querySelector("a.help-link");
    if (preRelPhone.textContent.length > 0 && preRelHelp) {
      preRelHelp.href = `tel:${preRelPhone.textContent.trim()}`;
      preRelObserver.disconnect();
    }
  });
  preRelObserver.observe(document.body, { childList: true, subtree: true });
    const openChatBtn = document.getElementById("openchatbtn");
  const infoPopup = document.querySelector(".chat-info-popup");

  if (!openChatBtn) return;
  openChatBtn.addEventListener("click", () => {
    // Query LPMcontainer at click time
    const LPMcontainer = document.querySelector(".LPMcontainer");
    if (LPMcontainer) {
      try {
        LPMcontainer.click();
      } catch (e) {
        console.error("Failed to trigger LPMcontainer click:", e);
        showPopup();
      }
    } else {
      showPopup();
    }
  });
  const closeBtn = infoPopup?.querySelector(".chat-info-close");
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      infoPopup.classList.remove("is-open");
    });
  }
  // Function to show popup and auto-remove after 10 seconds
  function showPopup() {
    if (!infoPopup) return;
    infoPopup.classList.add("is-open");
    // Remove popup automatically after 10 seconds
    setTimeout(() => {
      infoPopup.classList.remove("is-open");
    }, 10000); // 10000ms = 10 seconds
  }


        /* ---------- Legacy URL Handler (page load) ---------- */
  // Old URL mapping logic — run at the very end of DOMContentLoaded
  (() => {
  const oldToNewSections = {
    purchase: 'making_a_purchase',
    buying: 'buying_online',
    delivery: 'delivery_and_pickup',
    installation: 'installation_and_assembly',
    returns: 'policies_returns_and_exchanges',
    service: 'warranty_and_service',
    financing: 'financing_and_refunds'
  };

  const params = new URLSearchParams(window.location.search);
  let section = null;
  let questionSlug = null;

  // Extract only valid old section and Q param
  for (const [key, value] of params.entries()) {
    if (key === 'Q' && value) {
      questionSlug = value;
    } else if (oldToNewSections[key]) {
      section = oldToNewSections[key];
    }
  }

  // Only run if section exists
  if (!questionSlug && section && typeof activateSection === 'function') {
    activateSection(section);
  }

  // Only open question if both section and question exist
  if (section && questionSlug && typeof openQuestion === 'function') {
    const fullQuestionId = `${section}-${questionSlug}`;
    openQuestion(fullQuestionId, { type: 'section', section });
  }
  })();

});